'use client';

import clsx from 'clsx';
import ReactAudioPlayer from 'react-audio-player';

import styles from './index.module.scss';

/**
 * AudioPlayer component props.
 */

type Props = {
  src: string;
  autoPlay?: boolean;
  controls?: boolean;
  className?: string;
};

/**
 * AudioPlayer component.
 *
 * @see https://github.com/justinmc/react-audio-player
 */

const AudioPlayer = ({ className, src, autoPlay = false, controls = true, ...props }: Props) => {
  const classes = clsx(styles.player, className);

  return (
    <ReactAudioPlayer
      src={src}
      preload="auto"
      autoPlay={autoPlay}
      controls={controls}
      className={classes}
      {...props}
    />
  );
};

export default AudioPlayer;
